const TicketsData = [
  {
    name: 'One lesson',
    price: '30',
    path: '/oneLesson',
  },
  {
    name: 'One month',
    price: '200',
    path: '/oneMonth',
  },
  {
    name: 'Two months',
    price: '350',
    path: '/twoMonths',
  },
  {
    name: 'Three months',
    price: '450',
    path: '/threeMonths',
  },
  {
    name: 'Six months',
    price: '800',
    path: '/sixMonths',
  },
  {
    name: 'One year',
    price: '1400',
    path: '/oneYear',
  },
];

export default TicketsData;
